<template>
  <navbar>
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" style="color: #FFFFFF;" type="button" @click="mobileSidebarToggle">&#9776;</button>
    <a href="/">
      <img src="/static/img/gpo-logo.png" height="45">
    </a>
    <ul class="nav navbar-nav d-md-down-none">
      <!-- <li class="nav-item">
        <a class="nav-link navbar-toggler sidebar-toggler" href="#" @click="sidebarMinimize">&#9776;</a>
      </li> -->
      <!-- <li class="nav-item px-3">
        <a class="nav-link" href="#">Dashboard</a>
      </li>
      <li class="nav-item px-3">
        <a class="nav-link" href="#">Users</a>
      </li>
      <li class="nav-item px-3">
        <a class="nav-link" href="#">Settings</a>
      </li> -->
    </ul>
    <ul class="nav navbar-nav">

      <dropdown size="nav" class="nav-item">
        <span slot="button">
<!--           <img src="static/img/avatars/6.jpg" class="img-avatar" alt="admin@bootstrapmaster.com">
 -->          <span class="d-sm-down-none">{{ displayName }}</span>
        </span>
        <div slot="dropdown-menu"class="dropdown-menu dropdown-menu-right">

          <!-- <div class="dropdown-header text-center"><strong>Account</strong></div>

          <a class="dropdown-item" href="#"><i class="fa fa-bell-o"></i> Updates<span class="badge badge-info">42</span></a>
          <a class="dropdown-item" href="#"><i class="fa fa-envelope-o"></i> Messages<span class="badge badge-success">42</span></a>
          <a class="dropdown-item" href="#"><i class="fa fa-tasks"></i> Tasks<span class="badge badge-danger">42</span></a>
          <a class="dropdown-item" href="#"><i class="fa fa-comments"></i> Comments<span class="badge badge-warning">42</span></a>

          <div class="dropdown-header text-center"><strong>Settings</strong></div>

          <a class="dropdown-item" href="#"><i class="fa fa-user"></i> Profile</a>
          <a class="dropdown-item" href="#"><i class="fa fa-wrench"></i> Settings</a>
          <a class="dropdown-item" href="#"><i class="fa fa-usd"></i> Payments<span class="badge badge-default">42</span></a>
          <a class="dropdown-item" href="#"><i class="fa fa-file"></i> Projects<span class="badge badge-primary">42</span></a>
          <div class="divider"></div>
          <a class="dropdown-item" href="#"><i class="fa fa-shield"></i> Lock Account</a> -->
          <a class="dropdown-item" href="#" @click="signOut"><i class="fa fa-lock"></i> Logout</a>
        </div>
      </dropdown>
      <li class="nav-item d-md-down-none">
        <!-- <a class="nav-link navbar-toggler aside-menu-toggler" href="#" @click="asideToggle">&#9776;</a> -->
      </li>
    </ul>
  </navbar>
</template>
<script>
/* eslint-disable */
import navbar from './Navbar'
import { dropdown } from 'vue-strap'

export default {
  name: 'header',
  computed: {
    displayName: function () {
      if (window.firebase.auth().currentUser != null) {
        return window.firebase.auth().currentUser.displayName + " - " + window.firebase.auth().currentUser.email
      } else {
        return "Admin"
      }
    }
  },
  components: {
    navbar,
    dropdown
  },
  methods: {
    signOut : function(){

      var backToLogin = function(){
        this.$router.push('/pages/login');
      }

      window.firebase.auth().signOut().then(backToLogin.bind(this), function(error){
        console.log('Sign out error', error);
      })

    },
    click () {
      // do nothing
    },
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    }
  }
}
</script>

<style lang="css">
.app-header.navbar {
  border-bottom: 0px;
}
.username {
  font-weight: 350;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// Header.vue?363015fd